import { z } from "zod";

export const RequestContractVehiclesDtoSchema = z.object({
    nazov: z.string().nullish(),
    typ_voz: z.string().nullish(),
    spz: z.string().nullish(),
    vin: z.string().nullish(),
    rowId: z.number(),
    vehicleRowData: z.string().nullish(),
});

export type RequestContractVehiclesDto = z.infer<typeof RequestContractVehiclesDtoSchema>;